import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProgressDialogService {
  private _progress$: Subject<number> = new Subject<number>();

  public get progress$() {
    return this._progress$.asObservable();
  }

  public updateProgress(count: number): void {
    this._progress$.next(count);
  }
}
